import { StyledProps, React, withStyles, _, classNames } from '@api';
import { PrimaryIconButton } from 'centric-ui-components'
import { ListItem, ListItemText, ListItemSecondaryAction } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'

const styles = ({
  rectangle:     {
    cursor:    'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  disabledText:  {
    color: 'rgba(27, 27, 27, 0.38) !important'
  },
  listItemName:  {
    width:         '148px',
    height:        '20px',
    fontSize:      '14px',
    fontWeight:    'normal',
    fontStyle:     'normal',
    fontStretch:   'normal',
    lineHeight:    '1.43',
    letterSpacing: '0.2px',
    color:         'rgba(27, 27, 27, 0.87)',
    textOverflow:  'ellipsis',
    overflow:      'hidden',
    whiteSpace:    'nowrap'
  },
  itemContainer: {
    listStyle: 'none'
  },
  itemRoot:      {
    height: 48,
    padding: '8px 24px'
  },
  linkCSS:       {
    color: 'rgba(0, 0, 0, 0.38)',
    right: 16
  }
})

interface MyProps extends StyledProps {
  libraryItem?: { id?, name? }
  disableGutters?: boolean
  onClickTag?: (e, data) => void
  onRemoveTag?: (e, libraryItemId, libraryItemName) => void
  onDragStart?: (e) => void
  onDragEnd?: (e) => void
  listItemClass?: string
  selectedTags?: string[]
}

@(withStyles as any)(styles)
export class TagItemCard extends React.Component <MyProps> {
  static defaultProps = {
    onClickLibrary: () => {},
    disableGutters: false
  }

  render() {
    const {
            classes,
            libraryItem,
            onClickTag,
            onRemoveTag,
            disableGutters,
            onDragStart,
            onDragEnd,
            listItemClass,
            selectedTags
          } = this.props

    const isSelected = _.find(selectedTags, {id: libraryItem.id})
    return (
        <ListItem draggable onDragStart={onDragStart} onDragEnd={onDragEnd} className={isSelected ? null : (listItemClass || classes.rectangle)} disableGutters={disableGutters}
                  classes={{container: classes.itemContainer, root: classes.itemRoot}} onClick={isSelected ? () => {} : (e) => onClickTag(e, libraryItem)}>
          <ListItemText classes={isSelected ? {primary: classNames(classes.listItemName, classes.disabledText)} : {primary: classes.listItemName}} primary={libraryItem.name}
                        primaryTypographyProps={{title: libraryItem.name}}/>
          {isSelected && <ListItemSecondaryAction>
        <PrimaryIconButton
          icon={<Cancel className={classes.cancelIcon}/>}
          className={classes.linkCSS}
          onClick={e => onRemoveTag(e, libraryItem.id, libraryItem.name)}
        />
      </ListItemSecondaryAction>
          }
        </ListItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/TagItemCard.tsx